import { createContext, useContext } from 'react';

import type { NoticeBannersStackItems } from './NoticeBannersStackProvider';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Internal to garnish and intentionally left out of the barrel: only
 * `NoticeBannersStack` renders the stack. Everything else sends banners
 * with `useNoticeBannersStackActions`, which does not re-render on stack changes.
 */
export const NoticeBannersStackContext = createContext<NoticeBannersStackItems | undefined>(
  undefined,
);

export const useNoticeBannersStack = () => {
  const stack = useContext(NoticeBannersStackContext);

  if (stack === undefined) {
    throw new Error('useNoticeBannersStack must be used within a <NoticeBannersStackProvider>');
  }

  return stack;
};
